import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Award, Heart, User } from 'lucide-react';
import { useProgress } from '../context/ProgressContext';
export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    progress
  } = useProgress();
  const navItems = [{
    path: '/home',
    icon: Home,
    label: 'Home',
    color: 'from-blue-500 to-cyan-500'
  }, {
    path: '/stories',
    icon: BookOpen,
    label: 'Stories',
    color: 'from-purple-500 to-pink-500'
  }, {
    path: '/quizzes',
    icon: Award,
    label: 'Quizzes',
    color: 'from-green-500 to-teal-500'
  }, {
    path: '/resources',
    icon: Heart,
    label: 'Help',
    color: 'from-orange-500 to-red-500'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile',
    color: 'from-indigo-500 to-blue-500'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="fixed bottom-0 left-0 right-0 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border-t border-gray-200 dark:border-slate-700 z-50 md:hidden shadow-lg" data-id="element-202">
      <div className="flex items-center justify-around px-2 py-3" data-id="element-203">
        {navItems.map(item => {
        const Icon = item.icon;
        const active = isActive(item.path);
        return <button key={item.path} onClick={() => navigate(item.path)} className={`relative flex flex-col items-center space-y-1 px-3 py-2 rounded-2xl transition-all duration-300 ${active ? 'scale-110' : 'scale-100 opacity-70 hover:opacity-100'}`} data-id="element-204">
              {active && <div className={`absolute inset-0 bg-gradient-to-r ${item.color} opacity-10 rounded-2xl`} data-id="element-205" />}
              <div className={`relative ${active ? `bg-gradient-to-r ${item.color} p-2 rounded-xl shadow-lg` : 'p-2'}`} data-id="element-206">
                <Icon className={`w-5 h-5 ${active ? 'text-white' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-207" />
              </div>
              <span className={`text-xs font-semibold ${active ? 'gradient-text ' + item.color : 'text-gray-600 dark:text-gray-400'}`} data-id="element-208">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}